import React from 'react'
import Cards from '../assests/Why-choose-us-cards.png'
import { useMediaQuery } from 'react-responsive';

function Speacial() {

    const isLargeScreen = useMediaQuery({ minWidth: 1290 }); 

    return (
        <div className={`md:h-screen 100vw ${isLargeScreen ? 'arc' : 'rotated-gradient'} py-10`}>

        <div className=' md:max-w-[1240px] h-full p-5 md:mx-auto md:flex md:justify-between'>
            <div className='flex flex-col items-center md:items-start md:justify-evenly'>
                <div className='flex'>
                    <div className='py-11 text-center ellipse Special'>
                        <h1 className='text-white font-normal text-3xl ml-12'>Why Choose Us?</h1>
                    </div>
                </div>
                <div className='text-[#80AB9E] min-w-[300px] md:w-[450px] px-3 py-5  md:py-0 '>
                    <p className='text-xl py-3 text-center md:text-left'>
                        We specialize in creating captivating digital experiences that resonate
                        with your audience and drive real growth.
                    </p>
                    <p className=' text-xl py-3 text-center md:text-left'>
                        Through our expert web designing and social media management services,
                        we craft tailored solutions to elevate your brand to new heights.
                    </p>
                </div>
            </div>
            <div className='m-auto md:m-0 md:my-auto'>
                <img className='w-[400px] md:w-[520px] mx-auto md:mx-0' src={Cards} alt="" srcset="" />
            </div>
        </div>
        </div>
    )
}

export default Speacial